import React from "react";

interface ToggleProps {
    name: string;
    label: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
}

export default function Toggle({
    name,
    label,
    checked,
    onChange,
    disabled = false,
}: ToggleProps) {
    return (
        <div className="toggle-container">
            <label className="toggle-wrapper">
                <input
                    type="checkbox"
                    name={name}
                    className="toggle-input"
                    aria-label={label}
                    checked={checked}
                    onChange={(e) => onChange(e.target.checked)}
                    disabled={disabled}
                />
                <span className="toggle-track" />
                <span className="toggle-thumb" />
            </label>

            <span className="toggle-label-text">{label}</span>
        </div>
    );
}
